import { cn } from "@/lib/utils";
import { topToPageSelector } from "@/redux/globalState/globalStateSlice";
import { useMemo } from "react";
import { useSelector } from "react-redux";

import { APIStatus } from "../../../../api/APIStatus.type";
import { MetaRating } from "../../../../api/privateRequests/squad-builder/get-meta-ratings";
import { SavedSquad } from "../../../../api/privateRequests/squad-builder/get-squads";
import getFormation from "../../../../functions/getFormation";
import { PlayerRole } from "../../../../redux/players/playersSlice";
import {
  PlayerToInclude,
  RatingFilter,
  RightPanelMode,
  Scope,
  Squad,
  SquadBuilderMode,
  SquadBuilderPlayerType,
} from "../../../../redux/squadBuilder/squadBuilderUtils";
import { Tactic } from "../../../../redux/tactics/tacticsSlice";
import {
  RangeFilterType,
  SelectorFilterType,
  UpdateFilterType,
} from "../../../organisms/Filters/PlayerFilters/PlayerFilters";
import { ActiveFilter, FilterKey } from "../components/FiltersBar/FiltersBar";
import { ChemstyleMode } from "./ChemstyleMode/ChemstyleMode";
import { EvolvePlayerMode } from "./EvolvePlayerMode/EvolvePlayerMode";
import { InputMode } from "./InputMode/InputMode";
import { MoreFiltersMode } from "./MoreFiltersMode/MoreFiltersMode";
import { PlayerFiltersMode } from "./PlayerFiltersMode/PlayerFiltersMode";
import { PlayerMode } from "./PlayerMode/PlayerMode";
import { PlayerRoleMode } from "./PlayerRoleMode/PlayerRoleMode";
import { SuggestedSquadsMode } from "./SuggestedSquadsMode/SuggestedSquadsMode";

type Props = {
  mode: SquadBuilderMode;
  rightPanelMode: RightPanelMode;
  statusBuildSquad: APIStatus;
  budget: number;
  excludeIconsHeroes: boolean;
  ratingFilter: RatingFilter;
  scope: Scope;
  selectedCountries: number[];
  selectedLeagues: number[];
  selectedClubs: number[];
  selectedPnPs: number[];
  selectedMetals: number[];
  squad: Squad;
  useFormation: "chem-formation" | "in-game-formation";
  selectedVersions: number[];
  recommendedPlayers: SquadBuilderPlayerType[];
  handleDidAddPlayer: (
    playerRoleId: number,
    player?: SquadBuilderPlayerType,
    temp?: boolean,
    metaRatings?: MetaRating[],
    focus?: string,
  ) => void;
  handleClickedClose: () => void;
  handleGetPlayerRecommendations: () => void;
  playerRoles: PlayerRole[];
  handleBuildSquadFulfilled: () => void;
  handleClickedBuildSquads: () => void;
  handleSortBuiltSquads: (sortBy: "meta-rating" | "chemistry") => void;
  handleRemoveTempSquad: () => void;
  handleAddSquad: (index: number, temp: boolean) => void;
  handleClickedCloseSuggestedSquadsMode: () => void;
  handleClearSquad?: () => void;
  handleClickedCloseSquadOverview?: () => void;
  handleClickedCloseChemstyleMode?: () => void;
  handleClickedCloseEvolvePlayerMode?: () => void;
  handleClickedClosePlayerFiltersMode?: () => void;
  handleClickedCloseMoreFiltersMode?: () => void;
  handleSelectChemstyle?: (
    chemstyleId: number,
    metaRatings: MetaRating[],
  ) => void;
  handleClickSendToSquadBuilder?: () => void;
  handleChangeIngameFormation?: (formationIndex: number) => void;
  builtSquads: Squad[];
  playerFilters: (RangeFilterType | SelectorFilterType)[];
  handleUpdateFilter: (f: UpdateFilterType) => void;
  handleClearCustomFilter: (key: string) => void;
  handleClearFilter?: (key: FilterKey) => void;
  numberOfPlayersWithFilters?: number;
  inputFormationIndex?: number;
  playersToInclude?: PlayerToInclude[];
  changingPitchItemOnIndex?: number;
  availablePlayerRoles?: Record<string, boolean>;
  pitchIsFull?: boolean;
  statusGetRecommendedPlayers?: APIStatus;
  handleUpdateFormation?: (formationId: string, isTemp: boolean) => void;
  handleRemoveTempPlayer?: () => void;
  handleBudgetUpdated: (budget: number) => void;
  handleExcludeIconsHeroesUpdated: (excludeIconsHeroes: boolean) => void;
  handleMinRatingUpdated: (minRating: number) => void;
  handleMaxRatingUpdated: (maxRating: number) => void;
  handleScopeChange: (scope: Scope) => void;
  handleSelectedCountry: (id: number) => void;
  handleSelectedLeague: (id: number) => void;
  handleSelectedClub: (id: number) => void;
  handleSelectedPnP: (id: number) => void;
  handleSelectedMetal: (id: number) => void;
  handleSelectedVersion: (id: number) => void;
  handleClickedBack?: () => void;
  handleClickMoreFilters?: () => void;
  onBoardingStep?: number;
  chemOptimizing?: boolean;
  tabletOrLargerMode?: boolean;
  desktopMode?: boolean;
  savedSquads: SavedSquad[];
  loadedSaveSquadIndex: number;
  handleLoadSquad: (index: number) => void;
  handleLoadSquads: () => void;
  handleAddNewSquad: () => void;
  handleDeleteSquad: (squadId: string) => Promise<void>;
  activeFilters: ActiveFilter[];
  chosenTactic: Tactic;
  scrollPastTopBar: boolean;
  benchItems: SquadBuilderPlayerType[];
  handlePositionAndRoleChanged: (
    position: string,
    roleId: number,
    metaRatings: MetaRating[],
  ) => void;
  includeLoanPlayers: boolean;
  handleIncludeLoanPlayersUpdated: (includeLoanPlayers: boolean) => void;
};

export const RightPanel = ({
  mode,
  rightPanelMode,
  statusBuildSquad,
  budget,
  excludeIconsHeroes,
  ratingFilter,
  scope,
  selectedCountries,
  selectedLeagues,
  selectedClubs,
  selectedPnPs,
  selectedVersions,
  selectedMetals,
  recommendedPlayers,
  handleDidAddPlayer,
  handleRemoveTempPlayer,
  handleClickedClose,
  handleGetPlayerRecommendations,
  numberOfPlayersWithFilters,
  handleClearFilter,
  playersToInclude,
  changingPitchItemOnIndex,
  availablePlayerRoles,
  pitchIsFull,
  statusGetRecommendedPlayers,
  playerRoles,
  playerFilters,
  handleUpdateFilter,
  handleClearCustomFilter,
  handleBuildSquadFulfilled,
  handleUpdateFormation,
  handleClickedBuildSquads,
  onBoardingStep,
  handleClickedCloseSuggestedSquadsMode,
  // handleClickedCloseSquadOverview,
  handleClickedCloseChemstyleMode,
  handleSelectChemstyle,
  builtSquads,
  handleSortBuiltSquads,
  handleRemoveTempSquad,
  handleAddSquad,
  squad,
  // useFormation,
  // handleChangeIngameFormation,
  // handleClickedBack,
  // handleClickSendToSquadBuilder,
  handleClickMoreFilters,
  handleBudgetUpdated,
  handleExcludeIconsHeroesUpdated,
  handleMinRatingUpdated,
  handleMaxRatingUpdated,
  handleScopeChange,
  handleSelectedCountry,
  handleSelectedLeague,
  handleSelectedClub,
  handleSelectedPnP,
  handleSelectedMetal,
  handleSelectedVersion,
  // handleClearSquad,
  handleClickedCloseEvolvePlayerMode,
  handleClickedClosePlayerFiltersMode,
  handleClickedCloseMoreFiltersMode,
  chemOptimizing,
  tabletOrLargerMode,
  desktopMode,
  savedSquads,
  loadedSaveSquadIndex,
  handleLoadSquad,
  handleLoadSquads,
  handleAddNewSquad,
  handleDeleteSquad,
  activeFilters,
  chosenTactic,
  benchItems,
  scrollPastTopBar,
  handlePositionAndRoleChanged,
  includeLoanPlayers,
  handleIncludeLoanPlayersUpdated,
}: Props) => {
  const topToPage = useSelector(topToPageSelector);
  const player = useMemo(
    () =>
      squad.players[changingPitchItemOnIndex] ||
      playersToInclude?.[changingPitchItemOnIndex]?.player,
    [squad.players, changingPitchItemOnIndex, playersToInclude],
  );
  const benchPlayer = useMemo(
    () => benchItems[changingPitchItemOnIndex - 11],
    [benchItems, changingPitchItemOnIndex],
  );
  const playerRoleId = useMemo(
    () => player?.playerRoleId || benchPlayer?.playerRoleId,
    [player?.playerRoleId, benchPlayer?.playerRoleId],
  );
  const playerChemistry = useMemo(
    () =>
      squad.chemistry.playersChemistry?.[changingPitchItemOnIndex] ||
      player?.chemistry ||
      0,
    [
      squad.chemistry.playersChemistry,
      changingPitchItemOnIndex,
      player?.chemistry,
    ],
  );
  const selectedChemstyle = useMemo(
    () => player?.chemstyleId,
    [player?.chemstyleId],
  );

  return (
    <section
      className={cn(
        "bg-gray-100 w-full desktop:w-[260px] min-h-[115vh] mobile:min-h-50 sb-v2-lg:w-[352px] top-0 shrink-0 bg-side-panel shadow-right-panel bottom-0 pb-6 px-4 mobile:px-0 z-20 overflow-y-auto",
        scrollPastTopBar && desktopMode
          ? "fixed right-[max(0px,calc((100%-2000px)/2))]"
          : "absolute right-0",
        scrollPastTopBar && desktopMode && topToPage.tailwindString,
      )}
    >
      {rightPanelMode === "add-player-role" ? (
        <PlayerRoleMode
          mode={mode}
          handleClickedClose={handleClickedClose}
          handleRoleChanged={(playerRoleId, metaRatings, focus) => {
            handleDidAddPlayer(
              playerRoleId,
              undefined,
              false,
              metaRatings,
              focus,
            );
          }}
          playerRoles={playerRoles}
          changingPitchItemOnIndex={changingPitchItemOnIndex}
          pitchIsFull={pitchIsFull}
          availablePlayerRoles={availablePlayerRoles}
          player={changingPitchItemOnIndex > 10 ? benchPlayer : player}
          chemistry={playerChemistry}
          // position={
          //   getFormation(chosenTactic.teamTactics.formationId)?.labels[
          //     changingPitchItemOnIndex
          //   ]
          // }
          selectedFocus={
            chosenTactic.playerRoles[changingPitchItemOnIndex]?.focus
          }
          selectedPlayerRoleId={
            chosenTactic.playerRoles[changingPitchItemOnIndex]?.playerRoleId
          }
          isBench={changingPitchItemOnIndex > 10}
          handlePositionAndRoleChanged={handlePositionAndRoleChanged}
        />
      ) : rightPanelMode === "add-player" ? (
        <PlayerMode
          mode={mode}
          playerRoles={playerRoles}
          changingPitchItemOnIndex={changingPitchItemOnIndex}
          playersToInclude={playersToInclude}
          playerRoleId={playerRoleId}
          playersOnPitch={
            squad.players?.length > 0
              ? squad.players
              : playersToInclude?.map((p) => p.player)
          }
          playersOnBench={benchItems}
          recommendedPlayers={recommendedPlayers}
          availablePlayerRoles={availablePlayerRoles}
          pitchIsFull={pitchIsFull}
          handleClickedClose={handleClickedClose}
          handleDidAddPlayer={handleDidAddPlayer}
          handleRemoveTempPlayer={handleRemoveTempPlayer}
          handleGetPlayerRecommendations={handleGetPlayerRecommendations}
          statusGetRecommendedPlayers={statusGetRecommendedPlayers}
          tabletOrLargerMode={tabletOrLargerMode}
          desktopMode={desktopMode}
          formationPosition={
            getFormation(chosenTactic.teamTactics.formationId)?.labels[
              changingPitchItemOnIndex
            ]
          }
        />
      ) : rightPanelMode === "suggested-squads" ? (
        <SuggestedSquadsMode
          onBoardingStep={onBoardingStep}
          builtSquads={builtSquads}
          handleSortBuiltSquads={handleSortBuiltSquads}
          handleAddSquad={handleAddSquad}
          handleRemoveTempSquad={handleRemoveTempSquad}
          handleClickedClose={handleClickedCloseSuggestedSquadsMode}
          formationId={chosenTactic.teamTactics.formationId}
        />
      ) : rightPanelMode === "add-player-filters" ? (
        <PlayerFiltersMode
          handleClickedClose={handleClickedClosePlayerFiltersMode}
          filters={playerFilters}
          handleUpdateFilter={handleUpdateFilter}
          handleClearCustomFilter={handleClearCustomFilter}
        />
      ) : rightPanelMode === "select-chem-style" ? (
        <ChemstyleMode
          player={player}
          chemistry={playerChemistry}
          handleClickedClose={handleClickedCloseChemstyleMode}
          handleSelectChemstyle={handleSelectChemstyle}
          selectedChemstyle={selectedChemstyle}
        />
      ) : rightPanelMode === "add-evo-player" && player ? (
        <EvolvePlayerMode
          changingPitchItemOnIndex={changingPitchItemOnIndex}
          handleClickedClose={handleClickedCloseEvolvePlayerMode}
          handleDidEvolvePlayer={(player, temp) =>
            handleDidAddPlayer(player.playerRoleId, player, temp)
          }
          handleRemoveTempPlayer={handleRemoveTempPlayer}
          beforeEvoPlayer={player}
          chemistry={playerChemistry}
          playerRoles={playerRoles}
          formation={chosenTactic.teamTactics.formationId}
        />
      ) : rightPanelMode === "add-more-filters" ? (
        <MoreFiltersMode
          selectedPnPs={selectedPnPs}
          selectedVersions={selectedVersions}
          selectedMetals={selectedMetals}
          excludeIconsHeroes={excludeIconsHeroes}
          includeLoanPlayers={includeLoanPlayers}
          handleClickedClose={handleClickedCloseMoreFiltersMode}
          handleSelectedPnP={handleSelectedPnP}
          handleSelectedVersion={handleSelectedVersion}
          handleExcludeIconsHeroesUpdated={handleExcludeIconsHeroesUpdated}
          handleIncludeLoanPlayersUpdated={handleIncludeLoanPlayersUpdated}
          handleSelectedMetal={handleSelectedMetal}
        />
      ) : (
        <InputMode
          mode={mode}
          statusBuildSquad={statusBuildSquad}
          budget={budget}
          ratingFilter={ratingFilter}
          scope={scope}
          selectedCountries={selectedCountries}
          selectedLeagues={selectedLeagues}
          selectedClubs={selectedClubs}
          numberOfPlayersWithFilters={numberOfPlayersWithFilters}
          selectedFormation={chosenTactic.teamTactics.formationId}
          handleClearFilter={handleClearFilter}
          handleBuildSquadFulfilled={handleBuildSquadFulfilled}
          handleUpdateFormation={handleUpdateFormation}
          handleClickedBuildSquads={handleClickedBuildSquads}
          onBoardingStep={onBoardingStep}
          handleBudgetUpdated={handleBudgetUpdated}
          handleMinRatingChange={handleMinRatingUpdated}
          handleMaxRatingChange={handleMaxRatingUpdated}
          handleScopeChange={handleScopeChange}
          handleSelectedCountry={handleSelectedCountry}
          handleSelectedLeague={handleSelectedLeague}
          handleSelectedClub={handleSelectedClub}
          chemOptimizing={chemOptimizing}
          desktopMode={desktopMode}
          savedSquads={savedSquads}
          loadedSaveSquadIndex={loadedSaveSquadIndex}
          handleLoadSquad={handleLoadSquad}
          handleLoadSquads={handleLoadSquads}
          handleAddNewSquad={handleAddNewSquad}
          handleDeleteSquad={handleDeleteSquad}
          activeFilters={activeFilters}
          handleClickMoreFilters={handleClickMoreFilters}
        />
      )}
    </section>
  );
};
